import { render, staticRenderFns } from "./JeecgOrderModalForJVexTable.vue?vue&type=template&id=b67978c0&scoped=true&"
import script from "./JeecgOrderModalForJVexTable.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderModalForJVexTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67978c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b67978c0')) {
      api.createRecord('b67978c0', component.options)
    } else {
      api.reload('b67978c0', component.options)
    }
    module.hot.accept("./JeecgOrderModalForJVexTable.vue?vue&type=template&id=b67978c0&scoped=true&", function () {
      api.rerender('b67978c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/modules/JeecgOrderModalForJVexTable.vue"
export default component.exports